import React from 'react';
import Image from 'next/image';
import { Typography } from '@/components/common';

interface Props {
	signature: string;
}

const IMAGE_SIGNATURE_REGEX = /^(https?:\/\/|data:image\/)/i;

export const SignatureField: React.FC<Props> = ({ signature }) => {
	const isImage = IMAGE_SIGNATURE_REGEX.test(signature);

	return (
		<div className="flex flex-col gap-1">
			<Typography type="regular-12" className="text-gray-35 text-left">
				Signature:
			</Typography>
			<div className="min-h-[32px] flex items-end justify-center border-b border-opacity-black">
				<div className="flex items-center gap-0.5 self-start">
					<Typography type="regular-12" className="text-black">
						/s/
					</Typography>
					{isImage ? (
						<Image
							src={signature}
							alt="Client signature"
							width={255}
							height={30}
							className="w-[255px] h-[30px] max-w-full object-contain object-left"
						/>
					) : (
						<Typography type="regular-28" className="!font-praise">
							{signature}
						</Typography>
					)}
				</div>
			</div>
		</div>
	);
};
